import { ButtonGroupProps, Flex, useRadioGroup } from '@chakra-ui/react';
import * as React from 'react';
import { ToggleButtonProps } from './ToggleButton';

interface ToggleButtonGroupProps<T> extends Omit<ButtonGroupProps, 'onChange'> {
  name?: string;
  value: T;
  defaultValue?: string;
  onChange?: (value: T) => void;
}

export const ToggleButtonGroup = <T extends string>({ isDisabled, ...props }: ToggleButtonGroupProps<T>) => {
  const { children, name, defaultValue, value, onChange, ...rest } = props;
  const { getRootProps, getRadioProps } = useRadioGroup({
    name,
    defaultValue,
    value,
    onChange
  });

  const buttons = React.useMemo(
    () =>
      React.Children.toArray(children)
        .filter<React.ReactElement<ToggleButtonProps>>(React.isValidElement)
        .map((button) =>
          React.cloneElement(button, {
            radioprops: getRadioProps({
              value: button.props.value,
              disabled: isDisabled || button.props.isDisabled
            })
          })
        ),
    [children, getRadioProps, isDisabled]
  );
  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Flex {...getRootProps(rest)}>{buttons}</Flex>
    </>
  );
};
